






































import { Component, Mixins, Inject } from 'vue-property-decorator';
import TableComponent from '@/components/Table/TableComponent.vue';
import TableMixin from '@/mixins/tableMixins';
import { fetchDeclaration } from '@/api/drilldown';
import { exportDeclarationXML, exportDeclarationReport } from '@/api/export';
import { ExportType } from '@/models/Export';
import User from '@/models/User';
import UIPermissions from '@/models/UIPermissions';
import { FetchedData, View, AdditionalDataInfo, FetchedItem, IExport } from '@/interfaces';

@Component({
  components: {
    TableComponent,
  },
})
export default class ComplianceDeclaration extends Mixins(TableMixin) {
  @Inject() user!: User;

  public defaultView: View = {
    name: 'Default',
    fields: [
      'Substance',
      'CAS_Number',
      'Mass',
      'Calculated_Mass',
      'Result_Mass',
      'PPM',
      'Calculated_PPM',
      'Result_PPM',
      'Threshold_PPM',
      'Calculated_Compliance',
      'Declared_Compliance',
      'Result_Compliance',
      'Exemptions',
    ],
    default: false,
    selected: true,
  };

  public notSortable: string[] = ['all'];

  public additionalDataInfo: AdditionalDataInfo[] = [];

  get haveAccessToCustomDeclarationReportExport(): boolean {
    return this.user.permissions.includes(UIPermissions.CUSTOM_DECLARATION_REPORT_EXPORT);
  }

  get availableExportTypes(): ExportType[] | string[] {
    if (this.haveAccessToCustomDeclarationReportExport && this.partNumber.startsWith('5')) {
      return [ExportType.CSV, ExportType.XSLX, ExportType.XML, this.user.ui.declaration.report];
    }

    return [ExportType.CSV, ExportType.XSLX, ExportType.XML];
  }

  get processedData(): FetchedData {
    const processedDataItems: FetchedItem[] = [];
    this.data.items.forEach((e) => {
      if (!e.parentsIds) {
        processedDataItems.push(e);
      } else {
        const expandedItem = this.additionalDataInfo.find(
          (element) => e.parentsIds?.includes(element.id) && element.expanded
        );
        if (!expandedItem) {
          processedDataItems.push(e);
        } else if (!expandedItem.expanded) {
          processedDataItems.push(e);
        }
      }
    });
    return {
      itemsLength: this.data.itemsLength,
      items: processedDataItems,
      views: this.data.views,
    };
  }

  async mounted(): Promise<void> {
    this.getURLParams();
    await this.fetchData();
    this.isLoadingNewRecords = false;
    this.isExportDisabled = false;
    this.emitListener();
  }

  public async fetchData(): Promise<void> {
    this.isExportDisabled = true;
    const declarationData = await fetchDeclaration({
      id: this.idDeclaration,
      filters: this.query,
      lowerThreshold: this.itemsRange[0],
      upperThreshold: this.itemsRange[1],
      sortingName: this.sorting.name,
      sortingOrder: this.sorting.order,
    });
    this.data = {
      itemsLength: declarationData.itemsLength,
      items: declarationData.items,
      views: declarationData.views,
    };
    this.isExportDisabled = false;
  }

  public async exportDeclarationTable(exportDataParams: IExport): Promise<void> {
    this.isExportLoading = true;
    if (exportDataParams.format === ExportType.XML) {
      const fileName = `PART_${this.itemName}_${this.specification}_NUM_${this.declaration}.xml`;
      await exportDeclarationXML(this.idDeclaration, fileName);
    } else if (exportDataParams.format === this.user.ui.declaration.report) {
      const fileName = `PART_${this.itemName}_${this.specification}_NUM_${this.declaration}.xlsm`;
      await exportDeclarationReport(this.idDeclaration, fileName);
    } else {
      await this.exportTable(exportDataParams);
    }
    this.isExportLoading = false;
  }
}
